import { CAREFIRST_PARTNER_ID } from "@/constants/Partners";

const RESTRICTED_PARTNER_SEGMENT_COMBINATIONS: Array<{
  partnerId: number;
  segmentId: string;
}> = [
  { partnerId: CAREFIRST_PARTNER_ID, segmentId: "000000001102957" }, // CareFirst FEHBP
  { partnerId: CAREFIRST_PARTNER_ID, segmentId: "000000002021753" }, // CareFirst PSHBP
];

/**
 * Returns true if default sex and gender questions should be shown,
 * false if restricted questions should be shown.
 *
 * Restricted questions:
 * - Sex question: only "male" and "female" options
 * - Gender question: hidden entirely
 *
 * @param partnerId The partner id
 * @param segmentId The segment id
 * @returns true if default questions should be shown, false if restricted
 */
export function shouldShowDefaultSexAndGenderQuestions(
  partnerId: number | undefined,
  segmentId: string | undefined,
): boolean {
  if (partnerId === undefined || segmentId === undefined) {
    return true;
  }

  return !RESTRICTED_PARTNER_SEGMENT_COMBINATIONS.some(
    (combination) =>
      combination.partnerId === partnerId &&
      combination.segmentId === segmentId,
  );
}
